import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import Text from '@/components/Text'
import { logout, getPromotionInfo } from '@/api'
import { Icon } from '@cx/ui'
import { useRequest } from 'ahooks'
import { useNavigate } from 'react-router-dom'
import { UserInfo } from '@/types'
import { Avatar, Link, Stack, Box, List, ListItem, ListItemButton, ListItemText, ListItemIcon } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Badge, IdCard, IdInfo, InfoCard, Row, TagRow } from './components'
import { Message } from '@cx/ui'
export interface ProfilePanelProps {
  userInfo: UserInfo | null
  verified: boolean
  promotionInfo: any
}

export const OPT_LIST = [
  { name: '个人中心', icon: 'icon-gerenzhongxin', link: '/console/personal/base' },
  { name: '空间管理', icon: 'icon-kongjianguanli1', link: '/console/space/base' },
  { name: '订单管理', icon: 'icon-dingdanguanli1', link: '/console/space/order' },
]

const ProfilePanel: React.FC<ProfilePanelProps> = (props) => {
  const { userInfo, verified, promotionInfo } = props
  const [optList, setOptList] = useState(OPT_LIST)
  const navigate = useNavigate()
  const handleLogout = () => {
    logout().then(() => {
      window.open('/login', '_self')
    })
  }

  const toLink = (link: string) => () => {
    navigate(link)
  }

  const onCopy = useCallback(() => {
    Message.success('用户ID已复制到剪贴板')
  }, [])

  useEffect(() => {
    if (promotionInfo?.referral_code) {
      if (optList.findIndex((item) => item.name === '推广大使') === -1) {
        setOptList([
          ...optList.splice(2, 0, {
            name: '推广大使',
            icon: 'icon-tuiguangdashi',
            link: '/console/personal/promotion',
          }),
        ])
      }
    }
  }, [promotionInfo])

  return (
    <InfoCard>
      <IdCard>
        <IdInfo>
          <Avatar src={userInfo?.head_img_url ?? userInfo?.nickname} sx={{ width: 40 }} />
          <Stack>
            <Text
              size='xs'
              sx={{
                textOverflow: 'ellipsis',
                maxWidth: '10rem',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                fontWeight: 700,
                color: '#000',
              }}
              title={userInfo?.nickname}
            >
              {userInfo?.nickname}
            </Text>
            <Row sx={{ gap: '8px' }}>
              <Text
                size='xs'
                weight='thin'
                sx={{
                  textOverflow: 'ellipsis',
                  maxWidth: '10rem',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  color: 'rgba(0, 0, 0, 0.5)',
                }}
              >
                {userInfo?.id}
              </Text>

              <CopyToClipboard text={userInfo?.id?.toString() || ''} onCopy={onCopy}>
                <Icon
                  type='icon-copy'
                  sx={{
                    width: '12px',
                    color: 'primary.main',
                    cursor: 'pointer',
                  }}
                />
              </CopyToClipboard>
            </Row>
          </Stack>
        </IdInfo>
        <TagRow>
          <Badge state={verified ? 'success' : 'warning'}>
            {verified ? (
              <CheckCircleRoundedIcon sx={{ color: 'success.main', fontSize: 14, mr: 0.5 }} />
            ) : (
              <ErrorRoundedIcon sx={{ fontSize: 14, mr: 0.5 }} />
            )}
            {verified ? '已认证' : '未实名认证'}
          </Badge>
          {!verified && (
            <Link
              underline='none'
              sx={{
                display: 'flex',
                cursor: 'pointer',
                alignItems: 'center',
                color: 'primary.main',
                fontWeight: 400,
                fontSize: '12px',
              }}
              onClick={toLink('/console/personal')}
            >
              去认证
            </Link>
          )}
        </TagRow>
      </IdCard>

      <Box sx={{ borderBottom: '1px dashed #EEEEEE', mb: 2.5 }}></Box>

      <List sx={{ width: '100%', maxWidth: 360, py: 0, bgcolor: 'background.paper' }}>
        {OPT_LIST.map((item) => {
          return (
            <ListItem
              key={item.name}
              disablePadding
              sx={{
                height: 40,
                borderRadius: '4px',
                marginBottom: '4px',
                transition: 'background 0.3s',
                '&:hover': {
                  background: 'rgba(32,108,255,0.1)',
                },
              }}
            >
              <ListItemButton
                sx={{
                  '&:hover': {
                    background: 'transparent',
                  },
                }}
                onClick={() => {
                  navigate(item.link)
                }}
                dense
              >
                <ListItemIcon sx={{ minWidth: 34 }}>
                  <Icon type={item.icon} sx={{ fontSize: 16 }} />
                </ListItemIcon>
                <ListItemText sx={{ color: '#000' }} primary={item.name} />
              </ListItemButton>
            </ListItem>
          )
        })}
        <ListItem
          disablePadding
          sx={{
            height: 40,
            borderRadius: '4px',
            marginBottom: '4px',
            transition: 'background 0.3s',
            '&:hover': {
              background: 'rgba(246,78,84,0.06)',
            },
          }}
        >
          <ListItemButton
            onClick={handleLogout}
            dense
            sx={{
              '&:hover': {
                background: 'transparent',
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 34 }}>
              <Icon type={'icon-tuichu'} sx={{ fontSize: 16, color: 'error.main' }} />
            </ListItemIcon>
            <ListItemText sx={{ color: 'error.main' }} primary='退出' />
          </ListItemButton>
        </ListItem>
      </List>
    </InfoCard>
  )
}

export default ProfilePanel
